import React, { FC } from "react";

const NotFoundPage: FC = () => {
  return <div>{"We didn't find the page you were looking for."}</div>;
};

export default NotFoundPage;
